// Module
var code = "<div class=\"option-icon option-icon-default\" ng-if=\"!match.model.image_url\"></div><div class=\"option-icon\" ng-style=\"{'background-image' : match.model.image_url ? 'url(' + match.model.image_url + ')' : 'inherit'}\"></div><span class=\"option organization\" ng-bind-html=\"match.model.text | uibTypeaheadHighlight:query\"></span>";
// Exports
export default code;